import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  loadKnowledgeApiRag,
  type LoadKnowledgeRequest,
  type LoadKnowledgeResponse,
} from "@/generated/fastapi";

export async function loadKnowledge(
  accessToken: string | null | undefined,
  request: LoadKnowledgeRequest,
): Promise<LoadKnowledgeResponse | null> {
  try {
    const response = await loadKnowledgeApiRag({
      client: browserFastApiClient,
      body: request,
      auth: requireFastApiAccessToken(accessToken),
    });

    const loadKnowledgeResponse = response.data as LoadKnowledgeResponse;

    if (!response || loadKnowledgeResponse.status !== "success") {
      console.error("Load Knowledge failed response:", loadKnowledgeResponse);
      return loadKnowledgeResponse;
    }

    return loadKnowledgeResponse;
  } catch (error) {
    console.error("Load Knowledge error:", error);
    return null;
  }
}
